import React, { Component } from 'react';
import { Table, InputNumber, Input } from 'antd';
import TableText from "../../../../hr/components/TableText";
import computeNum from './compute';

const inputIndex = [1, 2, 3, 4, 5, 6, 10, 13, 14, 15, 16, 17, 18, 22, 25, 26, 27, 28, 29, 30, 34, 37, 38, 39, 40, 41, 42, 46, 53, 54];
const totalIndex = [0, 12, 24, 36];
const percentIndex = [8, 9, 20, 21, 32, 33, 44, 45, 49, 50, 57, 58];
class Index extends Component {
    onChange = (name, value, i) => {
        let json = JSON.stringify(this.props.data);
        let data = JSON.parse(json);
        data[i][name] = value;
        data = computeNum(data, this.props.dataTitle);
        this.props.onChange('data1', data);
    }

    render() {

        const columns = [{
            title: '名称',
            dataIndex: 'name',
            key: 'name',
            render: (text, record, index) => {
                return (
                    <div style={{ textAlign: "center" }}>
                        {text}
                    </div>
                )
            }
        }, {
            title: '天数',
            dataIndex: 'day',
            key: 'day',
            render: (text, record, index) => {
                return (
                    <div className="table-padding table-color-number">
                        <InputNumber
                            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            parser={value => value.replace(/\$\s?|(,*)/g, '')}
                            precision={0}
                            className="table_numInput"
                            defaultValue={Number(text || "0") || ""}
                            onBlur={(e) => {
                                let value = Number(e.target.value.replace(/,/g, '') || '0');
                                value = Number(value.toFixed(0));

                                let data = this.props.dataTitle;
                                data[index].day = value;
                                this.props.onChange('dataTitle', data);
                            }}

                        />
                    </div>
                )
            }
        }, {
            title: '日期名称',
            dataIndex: 'datename',
            key: 'datename',
            render: (text, record, index) => {
                return (
                    <div style={{ textAlign: "center" }}>
                        {text}
                    </div>
                )
            }
        }, {
            title: '日期',
            dataIndex: 'date',
            key: 'date',
            render: (text, record, index) => {
                return (
                    <div className="table-padding table-color-number">
                        <Input
                            className="table_numInput"
                            defaultValue={text}
                            onBlur={(e) => {
                                let value = e.target.value || "";
                                let data = this.props.dataTitle;
                                data[index].date = value;
                                this.props.onChange('dataTitle', data);
                            }}

                        />
                    </div>
                )
            }
        }];

        const columnsContent = [{
            title: '-',
            dataIndex: 'name',
            key: 'name',
            fixed: "left",
            width: 500,
            render: (text, record, index) => {
                return (
                    <div className={`table-padding ${totalIndex.includes(index) ? 'table-color-footer' : ''}`} style={{ textAlign: "left" }}>
                        {text}
                    </div>
                )
            }
        }, {
            title: 'Coffee Shop',
            dataIndex: 'shop',
            key: 'shop',
            width: 150,
            align: "center",
            render: (text, record, index) => {
                const type = inputIndex.includes(index) ? 'inputNumber' : percentIndex.includes(index) ? "percent" : 'number';
                const props = { text, index, type, name: "shop", onChange: this.onChange, totalIndex };
                if (totalIndex.includes(index)) {
                    return {
                        children: <TableText data={{ ...props, type: "" }} />,
                        props: {
                            colSpan: 12
                        }
                    }
                }
                return (
                    <TableText data={props} />
                )
            }
        }, {
            title: 'Chinese Restaurant',
            dataIndex: 'Chinese',
            key: 'Chinese',
            width: 150,
            align: "center",
            render: (text, record, index) => {
                const type = inputIndex.includes(index) ? 'inputNumber' : percentIndex.includes(index) ? "percent" : 'number';
                const props = { text, index, type, name: "Chinese", onChange: this.onChange, totalIndex };
                if (totalIndex.includes(index)) {
                    return {
                        children: <TableText data={{ ...props, type: "" }} />,
                        props: {
                            colSpan: 0
                        }
                    }
                }
                return (
                    <TableText data={props} />
                )
            }
        },
        //  {
        //     title: 'Thai Restaurant ',
        //     dataIndex: 'Thai',
        //     key: 'Thai',
        //     width: 150,
        //     align: "center",
        //     render: (text, record, index) => {
        //         const type = inputIndex.includes(index) ? 'inputNumber' : percentIndex.includes(index) ? "percent" : 'number';
        //         const props = { text, index, type, name: "Thai", onChange: this.onChange, totalIndex };
        //         if (totalIndex.includes(index)) {
        //             return {
        //                 children: <TableText data={{ ...props, type: "" }} />,
        //                 props: {
        //                     colSpan: 0
        //                 }
        //             }
        //         }
        //         return (
        //             <TableText data={props} />
        //         )
        //     }
        // },
        {
            title: 'Banquet ',
            dataIndex: 'banquet',
            key: 'banquet',
            width: 150,
            align: "center",
            render: (text, record, index) => {
                const type = inputIndex.includes(index) ? 'inputNumber' : percentIndex.includes(index) ? "percent" : 'number';
                const props = { text, index, type, name: "banquet", onChange: this.onChange, totalIndex };
                if (totalIndex.includes(index)) {
                    return {
                        children: <TableText data={{ ...props, type: "" }} />,
                        props: {
                            colSpan: 0
                        }
                    }
                }
                return (
                    <TableText data={props} />
                )
            }
        }, {
            title: 'Lobby Lounge',
            dataIndex: 'lounge',
            key: 'lounge',
            width: 150,
            align: "center",
            render: (text, record, index) => {
                const type = inputIndex.includes(index) ? 'inputNumber' : percentIndex.includes(index) ? "percent" : 'number';
                const props = { text, index, type, name: "lounge", onChange: this.onChange, totalIndex };
                if (totalIndex.includes(index)) {
                    return {
                        children: <TableText data={{ ...props, type: "" }} />,
                        props: {
                            colSpan: 0
                        }
                    }
                }
                return (
                    <TableText data={props} />
                )
            }
        }, {
            title: 'STEWARDING',
            dataIndex: 'stewarding',
            key: 'stewarding',
            width: 150,
            align: "center",
            render: (text, record, index) => {
                const type = inputIndex.includes(index) ? 'inputNumber' : percentIndex.includes(index) ? "percent" : 'number';
                const props = { text, index, type, name: "stewarding", onChange: this.onChange, totalIndex };
                if (totalIndex.includes(index)) {
                    return {
                        children: <TableText data={{ ...props, type: "" }} />,
                        props: {
                            colSpan: 0
                        }
                    }
                }
                return (
                    <TableText data={props} />
                )
            }
        }, {
            title: 'Others',
            dataIndex: 'others',
            key: 'others',
            width: 150,
            align: "center",
            render: (text, record, index) => {
                const type = inputIndex.includes(index) ? 'inputNumber' : percentIndex.includes(index) ? "percent" : 'number';
                const props = { text, index, type, name: "others", onChange: this.onChange, totalIndex };
                if (totalIndex.includes(index)) {
                    return {
                        children: <TableText data={{ ...props, type: "" }} />,
                        props: {
                            colSpan: 0
                        }
                    }
                }
                return (
                    <TableText data={props} />
                )
            }
        }, {
            title: 'Total',
            dataIndex: 'total',
            key: 'total',
            width: 150,
            align: "center",
            render: (text, record, index) => {
                const type = percentIndex.includes(index) ? "percent" : 'number';
                const props = { text, index, type, name: "stewarding", onChange: this.onChange, totalIndex };
                if (totalIndex.includes(index)) {
                    return {
                        children: <TableText data={{ ...props, type: "" }} />,
                        props: {
                            colSpan: 0
                        }
                    }
                }
                return (
                    <TableText data={props} />
                )
            }
        }, {
            title: 'Last Period Total',
            dataIndex: 'last',
            key: 'last',
            width: 150,
            align: "center",
            render: (text, record, index) => {
                const type = inputIndex.includes(index) ? 'inputNumber' : percentIndex.includes(index) ? "percent" : 'number';
                const props = { text, index, type, name: "last", onChange: this.onChange, totalIndex };
                if (totalIndex.includes(index)) {
                    return {
                        children: <TableText data={{ ...props, type: "" }} />,
                        props: {
                            colSpan: 0
                        }
                    }
                }
                return (
                    <TableText data={props} />
                )
            }
        }, {
            title: 'Var.',
            dataIndex: 'var',
            key: 'var',
            width: 150,
            align: "center",
            render: (text, record, index) => {
                const props = { text, index, type: "percent", name: "var", onChange: this.onChange, totalIndex };
                if (totalIndex.includes(index)) {
                    return {
                        children: <TableText data={{ ...props, type: "" }} />,
                        props: {
                            colSpan: 0
                        }
                    }
                }
                return (
                    <TableText data={props} />
                )
            }
        }, {
            title: 'Rooms',
            dataIndex: 'rooms',
            key: 'rooms',
            width: 150,
            align: "center",
            render: (text, record, index) => {
                const type = inputIndex.includes(index) ? 'inputNumber' : percentIndex.includes(index) ? "percent" : 'number';
                const props = { text, index, type, name: "rooms", onChange: this.onChange, totalIndex };
                if (totalIndex.includes(index)) {
                    return {
                        children: <TableText data={{ ...props, type: "" }} />,
                        props: {
                            colSpan: 0
                        }
                    }
                }
                return (
                    <TableText data={props} />
                )
            }
        }, {
            title: 'Last Period Total',
            dataIndex: 'last_total',
            key: 'last_total',
            width: 150,
            align: "center",
            render: (text, record, index) => {
                const type = inputIndex.includes(index) ? 'inputNumber' : percentIndex.includes(index) ? "percent" : 'number';
                const props = { text, index, type, name: "last_total", onChange: this.onChange, totalIndex };
                if (totalIndex.includes(index)) {
                    return {
                        children: <TableText data={{ ...props, type: "" }} />,
                        props: {
                            colSpan: 0
                        }
                    }
                }
                return (
                    <TableText data={props} />
                )
            }
        }, {
            title: 'Var.',
            dataIndex: 'last_var',
            key: 'last_var',
            width: 150,
            align: "center",
            render: (text, record, index) => {
                const props = { text, index, type: "percent", name: "last_var", onChange: this.onChange, totalIndex };
                if (totalIndex.includes(index)) {
                    return {
                        children: <TableText data={{ ...props, type: "" }} />,
                        props: {
                            colSpan: 0
                        }
                    }
                }
                return (
                    <TableText data={props} />
                )
            }
        }];


        return (
            <div style={{ marginTop: 30, width: this.props.print ? 2350 : 'auto' }} className="table7_1_1">
                <div>9.4.2 Operating Equipment Loss & Breakage Analysis  营运工具丢失破损分析</div>
                <Table
                    columns={columns}
                    dataSource={this.props.dataTitle}

                    showHeader={false}
                    style={{ width: 1000 }}
                    pagination={false}
                    bordered
                    className="content"
                    size="middle"
                    rowKey={record => record.name}
                />
                <Table
                    columns={columnsContent}
                    dataSource={this.props.data}
                    pagination={false}
                    bordered
                    className="content"
                    size="middle"
                    rowKey={(record, i) => i}
                    scroll={this.props.print ? {} : { y: 500, x: 2300 }}
                />
            </div>
        );
    }
}

export default Index;


// WEBPACK FOOTER //
// ./src/components/table/9.0/9-4/9-4-2.js